import { useEphattaMutation } from "hooks";
import { useCustomerRelationshipService } from "./useCustomerRelationshipService";

export const useCustomerRelationshipDelete = () => {
    const service = useCustomerRelationshipService()
    return useEphattaMutation(
        (id: number) => service.delete(id)
    )
}
